import React, { useEffect, useRef, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import { FiArrowRight } from "react-icons/fi";
import Budly4 from "./assets/10.jpeg";
import projectB from "./assets/11.jpeg";
import Budly1 from "./assets/12.jpeg";
import projectD from "./assets/13.jpeg";
import projectE from "./assets/14.jpeg";
import Budly2 from "./assets/9.PNG";
import projectG from "./assets/8.PNG";
import Budly3 from "./assets/7.jpeg";
import GeekVibz1 from "./assets/6.png";
import projectJ from "./assets/5.jpeg";
import GeekVibz2 from "./assets/4.png";
import GeekVibz3 from "./assets/3.png";
import projectM from "./assets/2.png";
import Puraminal from "./assets/1.png";
import BarbeRousse from "./assets/BarbeRousse.png";
import BarbeRousse1 from "./assets/BarbeRousse1.png";
import ClainDyeux from "./assets/ClainDyeux.png";
import ClainDyeux1 from "./assets/ClainDyeux1.png";
import Puraminal1 from "./assets/Puraminal.png";
import EduTrackz1 from "./assets/EduTrackz1.png";
import EduTrackz2 from "./assets/EduTrackz2.png";
import EduTrackz3 from "./assets/EduTrackz3.png";
import EduTrackz4 from "./assets/EduTrackz4.png";

// import GeekVibz1 from "./assets/1.png";

const shimmerGlow = keyframes`
  0% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.6;
  }
  100% {
    opacity: 0.1;
  }
`;

const Section = styled.section`
  width: 100%;
  padding: 100px 5vw 80px;
  background: rgb(178, 109, 227);
  position: relative;
  overflow: hidden;
  color: white;
`;

const Glow = styled.div`
  position: absolute;
  width: 360px;
  height: 360px;
  border-radius: 50%;
  top: 500px;
  filter: blur(80px);
  background: linear-gradient(to bottom, #7810c2, white);

  right: -100px;
  animation: ${shimmerGlow} 6s ease-in-out infinite;
  pointer-events: none;
`;

const Center = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0px;

  @media (max-width: 768px) {
    gap: 20px;
  }
`;

const Hero = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const HeroBadge = styled.span`
  align-self: flex-start;
  border-bottom: 1px solid white;
  padding: 8px 18px;
  font-size: 12px;
  letter-spacing: 2px;
  color: white;
`;

const HeroTitle = styled.h2`
  font-size: clamp(28px, 5vw, 48px);
  font-weight: 700;
  line-height: 1.2;
  text-transform: capitalize;
  color: white;

  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const HeroText = styled.p`
  max-width: 640px;
  line-height: 1.6;
  font-size: 16px;
  color: rgb(211, 208, 208);
`;

const CardGrid = styled.div`
  display: grid;
  gap: 30px;
  padding-top: 20px;
  flex-direction: column;

  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));

    gap: 10px;
  }
`;

const ProjectCard = styled.article`
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition:
    transform 0.5s ease,
    border 0.5s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.4);
  }
  ${({ expanded }) =>
    expanded &&
    css`
      border-color: rgba(255, 255, 255, 0.5);
    `}
`;

const ProjectContent = styled.div`
  padding: 20px 0;
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
  justify-content: space-between;
`;

const ProjectScope = styled.span`
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  color: #67a5eb;
`;

const ProjectName = styled.h3`
  font-size: 22px;
  margin: 0;
`;

const ProjectDescription = styled.p`
  font-size: 15px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.6;
  flex: 1;
`;

const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const Tag = styled.span`
  font-size: 12px;
  padding: 12px 18px;
  border-radius: 18px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.8);

  @media (max-width: 768px) {
    padding: 6px 12px;
  }
`;

const Action = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  cursor: pointer;
  background: white;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #000000;

  @media (max-width: 768px) {
    width: 50px;
    height: 50px;
  }
`;

const ExpandedPanel = styled.div`
  max-height: ${({ expanded }) => (expanded ? "none" : "0px")};
  opacity: ${({ expanded }) => (expanded ? 1 : 0)};
  transition: opacity 0.35s ease;
  overflow: visible;
  margin: ${({ expanded }) => (expanded ? "18px 0 0" : "0")};
  padding: ${({ expanded }) => (expanded ? "0px 0 10px 0" : "0 16px")};
`;

const ExpandedImages = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  flex-wrap: nowrap;
  gap: 12px;
  padding-top: ${({ expanded }) => (expanded ? "12px" : "0")};
  justify-content: flex-start;

  @media (max-width: 768px) {
    justify-content: center;
    flex-wrap: wrap;
    overflow-x: visible;
  }
`;

const ExpandedImage = styled.div`
  border-radius: ${({ $format }) => ($format === "desktop" ? "0px" : "20px")};
  background: ${(props) =>
    `linear-gradient(180deg, rgba(255, 255, 255, 0.1), rgba(249, 244, 244, 0.1)), url(${props.src})`};
  background-size: cover;
  background-position: center;
  flex-shrink: 0;
  width: ${({ $format }) => ($format === "desktop" ? "500px" : "140px")};
  height: ${({ $format }) => ($format === "desktop" ? "290px" : "300px")};

  @media (max-width: 768px) {
    width: ${({ $format }) => ($format === "desktop" ? "310px" : "140px")};
    height: ${({ $format }) => ($format === "desktop" ? "180px" : "300px")};
  }
`;

const SliderSection = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: auto;

  @media (max-width: 768px) {
    gap: 0px;
  }
`;

const SliderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 560px;
  border-radius: 26px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    height: 500;
  }
`;

const SlideItem = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => (props.active ? 1 : 0)};
  transition: opacity 0.6s ease;
  z-index: ${({ active }) => (active ? 2 : 1)};
`;

const SlideMeta = styled.div`
  width: 100%;
  padding: 0 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const SlideTitle = styled.p`
  margin: 0;
  color: #fff;
  font-size: clamp(18px, 3vw, 26px);
  letter-spacing: 0.75px;
  text-transform: uppercase;
  margin: 10px 0;

  @media (max-width: 768px) {
    font-size: 14px;
  }
`;

const SlideOverlay = styled.div`
  position: absolute;
  inset: 0;
  border-radius: 26px;
  pointer-events: none;
`;

const SlideContext = styled.span`
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

const SlideControls = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap: 8px;
`;

const ControlButton = styled.button`
  pointer-events: auto;
  background: rgba(0, 0, 0, 0.6);
  border: 1px solid rgba(255, 255, 255, 0.4);
  color: #fff;
  padding: 10px 16px;
  border-radius: 999px;
  font-size: 11px;
  letter-spacing: 1px;
  text-transform: uppercase;
  cursor: pointer;
  transition:
    opacity 0.3s ease,
    filter 0.3s ease;

  &:disabled {
    opacity: 0.4;
    filter: grayscale(0.7);
    cursor: not-allowed;
  }
`;

const Dots = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
`;

const Dot = styled.button`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: none;
  background: ${(props) => (props.active ? "#fff" : "rgba(255,255,255,0.3)")};
  cursor: pointer;
`;

const SlideFrame = styled.div`
  width: ${({ format }) => (format === "mobile" ? "260px" : "min(700px, 90%)")};

  height: ${({ format }) => (format === "mobile" ? "450px" : "400px")};

  /* --- ESTHÉTIQUE --- */
  border-radius: 20px;
  overflow: hidden; /* Coupe tout ce qui dépasse au cas où */

  /* --- CENTRAGE --- */
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto; /* Centre le cadre lui-même */
  border-radius: 20px;
`;

const SlideImage = styled.img`
  height: 90%;
  border-radius: 20px;

  /* MAGIE ICI : contain assure qu'on voit TOUTE l'image sans rogner */
  object-fit: contain;
  box-shadow: 0 0 10px 0 rgba(255, 255, 255, 0.9);

  display: block;
  margin: 10px 0;
`;

const projects = [
  {
    title: "GeekVibz App",
    description:
      "Application mobile éducative développée par GeekVibz . Notre objectif est d’offrir une expérience d’apprentissage ludique.",
    scope: "Mobile - Education",
    tags: ["Réseau social", "Apprendre", "Jouer"],
    gallery: [
      { src: GeekVibz1, format: "mobile" },
      { src: GeekVibz2, format: "mobile" },

      { src: GeekVibz3, format: "mobile" },
    ],
  },
  {
    title: "Budly App",
    description:
      "Budly App est une application mobile, alliant gamification , réseau social et IA dans le cadre de l'écologie.",
    scope: "Mobile - Social",
    tags: ["Gamification", "Réseau social", "IA"],
    gallery: [
      { src: Budly1, format: "mobile" },
      { src: Budly2, format: "mobile" },
      { src: Budly3, format: "mobile" },
      { src: Budly4, format: "mobile" },
    ],
  },
  {
    title: "EduTrackz",
    description: "EduTrackz est un SaaS de gestion pour professeurs privés.",
    scope: "SaaS - Education",
    tags: ["Gestion", "Administration", "SaaS"],
    gallery: [
      { src: EduTrackz1, format: "desktop" },
      { src: EduTrackz2, format: "desktop" },
      { src: EduTrackz3, format: "desktop" },
      { src: EduTrackz4, format: "desktop" },
    ],
  },
];

const sliderItems = [
  //   {
  //     name: "Barbe Rousse",
  //     image: BarbeRousse,
  //     format: "mobile",
  //   },
  {
    name: "Clain d'oeil institut",
    image: ClainDyeux,
    format: "desktop",
  },
  {
    name: "Shilamond",
    image: Puraminal1,
    context: "SaaS gestion professeurs",
    format: "mobile",
  },
  //   {
  //     name: "Barbe Rousse",
  //     image: BarbeRousse1,
  //     context: "Restaurant gastronomique",
  //     format: "mobile",
  //   },
];

const ProjectsShowcase = () => {
  const [expandedProject, setExpandedProject] = useState(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const activeSlideItem = sliderItems[activeSlide];
  const autoPlayRef = useRef(null);

  const startAutoPlay = () => {
    if (autoPlayRef.current) {
      clearInterval(autoPlayRef.current);
    }
    autoPlayRef.current = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % sliderItems.length);
    }, 5000);
  };

  const handleManualChange = (updater) => {
    setActiveSlide((prev) => updater(prev));
    startAutoPlay();
  };

  const goToPrevSlide = () =>
    handleManualChange(
      (prev) => (prev - 1 + sliderItems.length) % sliderItems.length,
    );

  const goToNextSlide = () =>
    handleManualChange((prev) => (prev + 1) % sliderItems.length);

  const toggleProject = (project) => {
    if (expandedProject?.title === project.title) {
      setExpandedProject(null);
      return;
    }

    setExpandedProject(project);
  };

  const isExpanded = (project) => expandedProject?.title === project.title;

  useEffect(() => {
    startAutoPlay();
    return () => {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
      }
    };
  }, []);

  return (
    <Section>
      {/* <Glow /> */}
      <Center>
        <Hero>
          <HeroBadge>Nos projets phares</HeroBadge>
          <HeroTitle>
            Chaque réalisation incarne l'excellence digitale que nos clients
            attendent.
          </HeroTitle>
          <HeroText>
            Nous orchestrons design de haut niveau, performance technique et
            accompagnement stratégique pour que vos plateformes web et mobiles
            soient performantes et convaincantes.
          </HeroText>
        </Hero>
        <CardGrid>
          {projects.map((project) => {
            const expanded = isExpanded(project);

            return (
              <ProjectCard
                key={project.title}
                expanded={expanded}
                onClick={() => toggleProject(project)}
              >
                <ProjectContent>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                    }}
                  >
                    <ProjectScope>{project.scope}</ProjectScope>
                    <ProjectName>{project.title}</ProjectName>
                    <Tags>
                      {project.tags.map((tag) => (
                        <Tag key={`${project.title}-${tag}`}>{tag}</Tag>
                      ))}
                    </Tags>
                  </div>
                  <>
                    <Action>+</Action>
                  </>
                </ProjectContent>

                <ExpandedPanel
                  expanded={expanded}
                  onClick={(event) => event.stopPropagation()}
                >
                  <ProjectDescription>{project.description}</ProjectDescription>

                  <ExpandedImages expanded={expanded}>
                    {project.gallery?.map(({ src, format }, index) => (
                      <ExpandedImage
                        key={`${project.title}-${index}`}
                        src={src}
                        $format={format}
                      />
                    ))}
                  </ExpandedImages>
                </ExpandedPanel>
              </ProjectCard>
            );
          })}
        </CardGrid>
        <p
          style={{
            textAlign: "center",
            marginTop: "20px",
            color: "rgba(255, 255, 255, 0.75)",
          }}
        >
          autres projets
        </p>
        <SliderSection>
          <SliderWrapper>
            {sliderItems.map((slide, index) => (
              <SlideItem key={slide.name} active={index === activeSlide}>
                <SlideFrame format={slide.format}>
                  <SlideImage
                    src={slide.image}
                    alt={slide.name}
                    $format={slide.format}
                  />
                </SlideFrame>
              </SlideItem>
            ))}
            <SlideOverlay />
          </SliderWrapper>
          <Dots>
            {sliderItems.map((_, index) => (
              <Dot
                key={`dot-${index}`}
                active={index === activeSlide}
                onClick={() => handleManualChange(() => index)}
              />
            ))}
          </Dots>
          {activeSlideItem && (
            <SlideMeta>
              <SlideTitle>{activeSlideItem.name}</SlideTitle>
            </SlideMeta>
          )}

          <SlideControls>
            <ControlButton type="button" onClick={goToPrevSlide}>
              ← Précédent
            </ControlButton>
            <ControlButton type="button" onClick={goToNextSlide}>
              Suivant →
            </ControlButton>
          </SlideControls>
        </SliderSection>
      </Center>
    </Section>
  );
};

export default ProjectsShowcase;
